import { Stripe, StripeElementsOptions } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'
import { CheckoutForm } from './CheckoutForm'
import { COLORS } from '../../utils/constants'
import { Totals } from '../../models/Checkout/Totals'

interface StripeCheckoutWrapperProps {
  clientSecret: string
  totals: Totals
  stripePromise: Promise<Stripe | null>
  discount?: number
  bundleTotal?: number
  hasCheckoutItems: boolean
}
function StripeCheckoutWrapper(props: StripeCheckoutWrapperProps) {
  const { clientSecret, totals, stripePromise, discount, bundleTotal, hasCheckoutItems } =
    props
  const options: StripeElementsOptions = {
    clientSecret,
    appearance: {
      variables: {
        borderRadius: '12px',
        colorPrimary: COLORS.BasicTextGray.toString(),
      },
    },
  }

  return (
    <Elements stripe={stripePromise} options={options}>
      <CheckoutForm
        totals={totals}
        discount={discount}
        bundleTotal={bundleTotal}
        hasCheckoutItems={hasCheckoutItems}
      />
    </Elements>
  )
}

export default StripeCheckoutWrapper
